import { Link } from 'react-router-dom';
import { OrderCard } from '../components/orders/OrderCard';
import { useMyOrders } from '../hooks/useOrders';

export function OrderHistory() {
  const { orders, isLoading, error } = useMyOrders();

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-8 space-y-4">
      <header className="flex items-baseline justify-between">
        <h1 className="font-display text-3xl">Your orders</h1>
        <Link to="/order" className="text-sm text-wca-red hover:underline font-medium">
          New order →
        </Link>
      </header>

      {isLoading ? (
        <p className="text-center text-wca-gray-mid font-mono text-sm py-12">Loading…</p>
      ) : error !== null ? (
        <p className="text-center text-wca-red py-12">{error}</p>
      ) : orders.length === 0 ? (
        <div className="text-center py-12 px-6">
          <p className="font-display text-xl">No orders yet</p>
          <p className="text-sm text-wca-gray-mid mt-2">
            Your past orders show up here once you place one.
          </p>
          <Link to="/order" className="inline-block mt-6 text-wca-red hover:underline font-medium">
            Browse the menu →
          </Link>
        </div>
      ) : (
        <ul className="space-y-3">
          {orders.map((order) => (
            <li key={order.orderId}>
              <OrderCard order={order} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
